export const getDisplayName = (supplierName, activeBrands) => {
    // Check if supplierName is an array and extract the string if necessary
    const supplierNameString = Array.isArray(supplierName) ? supplierName[0] : supplierName;
    // Now find the brand using the string
    const brand = activeBrands.find(brand => brand.name === supplierNameString);
    // console.log('Brand in getDisplay name',activeBrands);
    // Return the displayName if the brand is found, otherwise return the supplierNameString
    return brand ? brand.displayName : supplierNameString;
};
